_ = require('lodash')

PlayerAPIService = ($rootScope, $http, $q) ->
  owner = null

  $rootScope.$on 'signedIn.gnp.authService', -> #fires when user sign-in
    owner = null
  $rootScope.$on 'accountUpdated.gnp.AccountService', -> #fires when user update account
    owner = null

  clearOwnerCache: ->
    owner = null

  search: (query) ->
    url = "/api/players/search.json"
    delay = $q.defer()
    $http.get(url, params: q: query).then (resp) ->
      delay.resolve reesp.data
    delay.promise

  getOwnerPlayer: ->
    delay = $q.defer()
    unless owner
      $http.get("/api/players/me.json").then (resp) ->
        resp.data.scores = []
        owner = resp.data
        delay.resolve owner
    else
      delay.resolve owner
    delay.promise

  savePlayers: (players) ->
    data = _.reject players, (p) -> not p.name
    $http.put "/api/players/batch_update.json", players: data


PlayerAPIService.$inject = [
  '$rootScope'
  '$http'
  '$q'
]

module.exports = PlayerAPIService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/remote-api/player-api-service.coffee